export default function render(parameter, parameterValue) {
  return parameterValue.value;
}
